import React, { useState } from "react";
import ConstantsImages from "../../constants/ConstantsImages";
import { DivColumn, DivRow, ParagraphText, WidgetMarginHeight, WidgetMarginWidth } from "../../styles/SharedStyles";
import UtilsUnit from "../../utils/UtilsUnit";
import WidgetIcon from "../../widgets/icons/widget-icon/WidgetIcon";
import { usePageDashboard } from "./usePageDashboard";
import ConstantsTexts from "../../constants/ConstantsTexts";
import WidgetModelVersionDropdown from "../../widgets/dropdowns/widget-model-version-dropdown/WidgetModelVersionDropdown";
import WidgetIconFour from "../../widgets/icons/widget-icon-four/WidgetIconFour";
import WidgetGaugeUI from "../../widgets/shared_widgets/widget-gauge-ui/WidgetGaugeUI";
import WidgetMarkersMap from "../../widgets/maps/widget-markers-map/WidgetMarkersMap";
import WidgetModelIcon from "../../widgets/shared_widgets/widget-model-icon/WidgetModelIcon";
import WidgetSmallTransportationTitle from "../../widgets/shared_widgets/widget-small-transportation-title/WidgetSmallTransportationTitle";
import WidgetSearchFrame from "../../widgets/shared_widgets/widget-search-frame/WidgetSearchFrame";
import WidgetDropdown, { DropdownType } from "../../widgets/dropdowns/widget-dropdown/WidgetDropdown";
import WidgetFixedSizeList from "../../widgets/shared_widgets/widget-fixed-size-list/WidgetFixedSizeList";
import WidgetIconFive from "../../widgets/icons/widget-icon-five/WidgetIconFive";
import WidgetCreateTerminalIcon from "../../widgets/shared_widgets/widget-create-terminal-icon/WidgetCreateTerminalIcon";
import WidgetUsersIcon from "../../widgets/shared_widgets/widget-users-icon/WidgetUsersIcon";
import WidgetChangeRequestsIcon from "../../widgets/shared_widgets/widget-change-requests-icon/WidgetChangeRequestsIcon";
import WidgetTooltipWrapper from "../../widgets/shared_widgets/widget-tooltip-wrapper/WidgetTooltipWrapper";
import WidgetFrozenVersionBadge from "../../widgets/shared_widgets/widget-frozen-version-badge/WidgetFrozenVersionBadge";
import WidgetAlertDialogFrozenTerminalBlocked from "../../widgets/alert-dialogs/widget-alert-dialog-frozen-terminal-blocked/WidgetAlertDialogFrozenTerminalBlocked";

// CSS/Stylesheets
import "./PageDashboard.css";

function PageDashboard() {
  const [isFrozenTerminalBlockedOpen, setIsFrozenTerminalBlockedOpen] = useState(false);

  const {
    dataIsReceived,
    userData,
    handleSearchTerminalIconClick,
    uniqueDistricts,
    handleSelectDropdownDistrict,
    selectedDistrict,
    uniquePlanningSpace,
    handleSelectDropdownPlanningSpace,
    selectedPlanningSpace,
    uniqueMunicipalities,
    handleSelectDropdownMunicipality,
    selectedMunicipality,
    uniqueTerminals,
    handleSelectDropdownTerminal,
    selectedTerminal,
    showSearchTerminal,
    nationalModelForTerminalFiltered,
    mapMarkers,
    getZoomCoordinates,
    handleSelectTerminalFromList,
    activeTooltip,
    handleTooltipClick,
    getMainMeasurePercent,
    getMainMeasurePercentComparison,
    getSecondaryMeasurePercentForDisplay,
    getSecondaryMeasurePercentForDisplayComparison,
    tooltipRef,
    terminalNameSlicer,
    municipalitySlicer,
    districtSlicer,
    terminalTypeSlicer,
    terminalStatusSlicer,
    budgetStatusSlicer,
    organizationInChargeSlicer,
    selectedTerminalNameSlicer,
    handleSelectTerminalNameSlicer,
    selectedMunicipalitySlicer,
    handleSelectMunicipalitySlicer,
    selectedDistrictSlicer,
    handleSelectDistrictSlicer,
    selectedTerminalTypeSlicer,
    handleSelectTerminalTypeSlicer,
    selectedTerminalStatusSlicer,
    handleSelectTerminalStatusSlicer,
    selectedBudgetStatusSlicer,
    handleSelectBudgetStatusSlicer,
    selectedOrganizationInChargeSlicer,
    handleSelectOrganizationInChargeSlicer,
    getSecondaryMeasureDetails,
    selectedItemId,
    getTerminalRowKey,
    isTerminalRowSelected,
    exportToExcel,
    isCollapsed,
    handleToggleCollapse,
    getDashboardFrameWidth,
    getMapWidth,
    handleClear,
    listRef,
    hasActiveFilters,
    selectedModelVersion,
    handleSelectModelVersion,
    modelVersions,
    isComparisonMode,
    handleCancelComparisonMode,
    handleSetComparisonMode,
    selectedModelVersion2,
    handleSelectModelVersion2,
    getFilteredModelVersionsForFirst,
    getFilteredModelVersionsForSecond,
    isModelVersionFrozen,
    isComparisonModeEnabled,
  } = usePageDashboard();

  if (!dataIsReceived) {
    return <div />;
  }

  return body();

  function body() {
    return (
      <>
        <div className="page-dashboard-container">
          <DivColumn style={{ width: "225rem" }}>
            <DivRow className="dashboard-1-frame-1">
              {rightDesignUi()}
              {dashboardDesignGeneral()}
              {!isComparisonMode && mapUi()}
            </DivRow>
          </DivColumn>
        </div>
        {isFrozenTerminalBlockedOpen && (
          <WidgetAlertDialogFrozenTerminalBlocked onClose={() => setIsFrozenTerminalBlockedOpen(false)} />
        )}
      </>
    );
  }

  function rightDesignUi() {
    return (
      <DivColumn className="dashboard-7-frame" style={{ minHeight: "90.4rem" }}>
        <WidgetSmallTransportationTitle />
        <WidgetMarginHeight height="1.7rem" />
        <WidgetSearchFrame
          showSearchTerminal={showSearchTerminal}
          handleSearchTerminalIconClick={handleSearchTerminalIconClick}
          uniqueDistricts={uniqueDistricts}
          uniquePlanningSpace={uniquePlanningSpace}
          uniqueMunicipalities={uniqueMunicipalities}
          uniqueTerminals={uniqueTerminals}
          selectedDistrict={selectedDistrict}
          selectedPlanningSpace={selectedPlanningSpace}
          selectedMunicipality={selectedMunicipality}
          selectedTerminal={selectedTerminal}
          handleSelectDropdownDistrict={handleSelectDropdownDistrict}
          handleSelectDropdownPlanningSpace={handleSelectDropdownPlanningSpace}
          handleSelectDropdownMunicipality={handleSelectDropdownMunicipality}
          handleSelectDropdownTerminal={handleSelectDropdownTerminal}
        />
        <WidgetMarginHeight height="0.5rem" />
        <WidgetModelIcon userData={userData} />
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetCreateTerminalIcon
              isCreateBlocked={isModelVersionFrozen(selectedModelVersion)}
              onCreateBlocked={() => setIsFrozenTerminalBlockedOpen(true)}
            />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetUsersIcon />
          </>
        )}
        {UtilsUnit.managerUser(userData) && (
          <>
            <WidgetMarginHeight height="0.5rem" />
            <WidgetChangeRequestsIcon />
          </>
        )}
      </DivColumn>
    );
  }

  function dashboardDesignGeneral() {
    return (
      <DivColumn className="dashboard-2-frame" style={{ width: getDashboardFrameWidth() }}>
        {exportVersionHeader()}
        {metricsContainer()}
      </DivColumn>
    );
  }

  function exportVersionHeader() {
    return (
      <DivRow className="dashboard-2-frame-1">
        <DivRow className="dashboard-2-frame-2">
          <WidgetIconFour iconProp={ConstantsImages.XLS_IMAGE} handleOnClickProp={exportToExcel} widthIconProp="4.6rem" heightIconProp="6.2rem" />
          {isModelVersionFrozen(selectedModelVersion) && <WidgetFrozenVersionBadge />}
          <WidgetModelVersionDropdown
            widthProp="20rem"
            options={isComparisonMode ? getFilteredModelVersionsForFirst() : modelVersions}
            onSelect={handleSelectModelVersion}
            selectedOptionProp={selectedModelVersion}
          />
        </DivRow>
        {isComparisonModeEnabled() && (
          <DivRow className="dashboard-2-frame-3">
            <WidgetTooltipWrapper content={ConstantsTexts.CODE_236}>
              <WidgetIcon
                iconProp={ConstantsImages.COMPARISON_MODE_IMAGE}
                heightProp="6.6rem"
                heightIconProp="1.9rem"
                widthIconProp="1.9rem"
                backgroundColorProp={"#2B308B"}
                handleOnClickProp={handleSetComparisonMode}
                customClassNameProp="widget-twelve-icon"
              ></WidgetIcon>
            </WidgetTooltipWrapper>
          </DivRow>
        )}
        {isComparisonMode && (
          <>
            <WidgetModelVersionDropdown
              widthProp="20rem"
              options={getFilteredModelVersionsForSecond()}
              onSelect={handleSelectModelVersion2}
              selectedOptionProp={selectedModelVersion2}
            />
            {isModelVersionFrozen(selectedModelVersion2) && <WidgetFrozenVersionBadge />}
            <WidgetIcon
              iconProp={ConstantsImages.CLOSE_3_IMAGE}
              heightProp="6.6rem"
              widthIconProp="1rem"
              heightIconProp="1rem"
              backgroundColorProp={"#2E2E2E"}
              handleOnClickProp={handleCancelComparisonMode}
            />
          </>
        )}
      </DivRow>
    );
  }

  function metricsContainer() {
    return (
      <DivColumn className="dashboard-3-frame-container" style={{ position: "relative" }}>
        {metricsContainerComparisonBackground()}
        <DivRow>
          {metricsHeader()}
          {isComparisonMode && metricsHeaderComparison()}
        </DivRow>
        {filtersMetricsRow()}
        {terminalsList()}
      </DivColumn>
    );
  }

  function metricsContainerComparisonBackground() {
    return (
      isComparisonMode && (
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "15.85%",
            transform: "translateX(-50%)",
            width: "57.2rem",
            height: "72rem",
            borderRadius: "1.5rem",
            background: "rgba(212, 215, 229, 0.66)",
            zIndex: -1,
          }}
        />
      )
    );
  }

  function metricsHeader() {
    return metricsHeaderContent();
  }

  function metricsHeaderComparison() {
    return metricsHeaderContent(true);
  }

  function metricsHeaderContent(comparisonLayout = false) {
    return (
      <DivRow
        className={`dashboard-3-frame ${isCollapsed ? "collapsed" : ""}`}
        style={{ padding: comparisonLayout ? "0rem 14.5rem 0.5rem 0rem" : isCollapsed ? "0rem 36.7rem 0.5rem 0rem" : "0rem 65.9rem 0.5rem 0rem" }}
      >
        <DivRow className="dashboard-3-frame-1">
          <DivColumn className="dashboard-3-frame-2">
            <DivRow className="dashboard-3-frame-3">
              {metricTooltipItem({ key: 1, title: ConstantsTexts.CODE_17, comparisonLayout })}
              {metricTooltipItem({ key: 2, title: ConstantsTexts.CODE_39, comparisonLayout })}
              {metricTooltipItem({ key: 3, title: ConstantsTexts.CODE_21, comparisonLayout })}
              {metricTooltipItem({ key: 4, title: ConstantsTexts.CODE_136, comparisonLayout })}
            </DivRow>
          </DivColumn>
          <DivColumn className="dashboard-3-frame-5">{metricTooltipItem({ key: 7, width: "5.6rem", title: ConstantsTexts.CODE_137, comparisonLayout })}</DivColumn>
          <DivColumn className="dashboard-3-frame-6">
            <DivRow className="dashboard-3-frame-7">
              {metricTooltipItem({ key: 6, width: "6.2rem", title: ConstantsTexts.CODE_26, comparisonLayout })}
              {metricTooltipItem({ key: 5, width: "5.6rem", title: ConstantsTexts.CODE_25, comparisonLayout })}
            </DivRow>
          </DivColumn>
        </DivRow>
      </DivRow>
    );
  }

  // Renders tooltip with icon, text content, and arrow pointer
  function Tooltip({ isVisible, children }) {
    if (!isVisible) return null;

    return (
      <div className="dashboard-tooltip-container" ref={tooltipRef}>
        <div className="dashboard-tooltip-content">
          <WidgetIconFive iconProp={ConstantsImages.TOOLTIP_2_IMAGE} widthIconProp="1.3rem" heightIconProp="1.2rem" />
          <div className="dashboard-tooltip-text">{children}</div>
          <div className="dashboard-tooltip-arrow"></div>
        </div>
      </div>
    );
  }

  // Renders metric tooltip item with clickable tooltip icon and percentage display for comparison mode
  function metricTooltipItem({ key, width = "5.2rem", title, comparisonLayout = false }) {
    const tooltipId = `tooltip-${key}-${comparisonLayout ? "comparison" : "normal"}`;
    const isTooltipVisible = activeTooltip === tooltipId;

    return (
      <DivColumn className="dashboard-3-frame-4" style={{ width: width }}>
        {!isComparisonMode && (
          <div className={`dashboard-3-frame-4-tooltip-container ${isCollapsed ? "collapsed" : ""}`}>
            <WidgetIconFour
              iconProp={ConstantsImages.TOOLTIP_IMAGE}
              widthIconProp="1.4rem"
              heightIconProp="1.4rem"
              handleOnClickProp={(e) => {
                e.stopPropagation();
                handleTooltipClick(tooltipId);
              }}
            />
            <Tooltip isVisible={isTooltipVisible}>{getSecondaryMeasureDetails(key)}</Tooltip>
          </div>
        )}
        <ParagraphText className="dashboard-text-1">{title}</ParagraphText>
        <ParagraphText className="dashboard-text-2">
          {comparisonLayout ? getSecondaryMeasurePercentForDisplayComparison(key) : getSecondaryMeasurePercentForDisplay(key)}
        </ParagraphText>
      </DivColumn>
    );
  }

  function filtersMetricsRow() {
    return (
      <DivRow className="dashboard-4-frame">
        {filterDropdownsRow()}
        {metricsSummaryRow()}
        {legendContainer()}
        {isComparisonMode && (
          <>
            <WidgetMarginWidth width="0rem" />
            {metricsSummaryRow(true)}
            {legendContainer()}
          </>
        )}
      </DivRow>
    );
  }

  function filterDropdownsRow() {
    return (
      <DivRow className={`dashboard-4-frame-1 ${isCollapsed ? "collapsed" : ""}`}>
        {filterDropdownItem({
          width: "9.7rem",
          title: ConstantsTexts.CODE_65,
          options: terminalNameSlicer,
          labelKey: "terminal_info",
          onSelect: handleSelectTerminalNameSlicer,
          selectedOptionProp: selectedTerminalNameSlicer,
          enableSearch: true,
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectTerminalNameSlicer, true),
        })}
        {filterDropdownItem({
          width: "8.2rem",
          title: ConstantsTexts.CODE_69,
          options: terminalStatusSlicer,
          labelKey: "terminalStatusName",
          onSelect: handleSelectTerminalStatusSlicer,
          selectedOptionProp: selectedTerminalStatusSlicer,
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectTerminalStatusSlicer),
          type: DropdownType.MULTI_SELECT,
        })}
        {filterDropdownItem({
          width: "7.5rem",
          title: ConstantsTexts.CODE_64,
          options: municipalitySlicer,
          labelKey: "municipalityName",
          onSelect: handleSelectMunicipalitySlicer,
          selectedOptionProp: selectedMunicipalitySlicer,
          enableSearch: true,
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectMunicipalitySlicer),
          type: DropdownType.MULTI_SELECT,
        })}
        {filterDropdownItem({
          width: "8.6rem",
          title: ConstantsTexts.CODE_63,
          options: districtSlicer,
          labelKey: "districtMOTName",
          onSelect: handleSelectDistrictSlicer,
          selectedOptionProp: selectedDistrictSlicer,
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectDistrictSlicer),
          type: DropdownType.MULTI_SELECT,
        })}
        {filterDropdownItem({
          width: "5.1rem",
          title: ConstantsTexts.CODE_144,
          options: terminalTypeSlicer,
          labelKey: "terminalTypeName",
          onSelect: handleSelectTerminalTypeSlicer,
          selectedOptionProp: selectedTerminalTypeSlicer,
          className: isCollapsed ? "collapsed" : "",
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectTerminalTypeSlicer),
          type: DropdownType.MULTI_SELECT,
        })}
        {filterDropdownItem({
          width: "9.8rem",
          title: ConstantsTexts.CODE_146,
          options: budgetStatusSlicer,
          labelKey: "budgetStatusName",
          onSelect: handleSelectBudgetStatusSlicer,
          selectedOptionProp: selectedBudgetStatusSlicer,
          className: isCollapsed ? "collapsed" : "",
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectBudgetStatusSlicer),
          type: DropdownType.MULTI_SELECT,
        })}
        {filterDropdownItem({
          width: "9.8rem",
          title: ConstantsTexts.CODE_123,
          options: organizationInChargeSlicer,
          labelKey: "organizationInChargeName",
          onSelect: handleSelectOrganizationInChargeSlicer,
          selectedOptionProp: selectedOrganizationInChargeSlicer,
          className: isCollapsed ? "collapsed" : "",
          enableClear: true,
          onClear: (e) => handleClear(e, handleSelectOrganizationInChargeSlicer),
          type: DropdownType.MULTI_SELECT,
        })}
      </DivRow>
    );
  }

  // Renders filter dropdown with configurable search, clear functionality, and multi-select support
  function filterDropdownItem({
    title,
    width,
    options,
    labelKey,
    onSelect,
    selectedOptionProp,
    enableSearch = false,
    enableClear = false,
    className = "",
    onClear,
    type = DropdownType.DEFAULT_SELECT,
  }) {
    return (
      <DivColumn className={`dashboard-4-frame-2 ${className}`} style={{ width: width }}>
        <DivRow className="dashboard-4-frame-3">
          <WidgetDropdown
            options={options}
            labelKey={labelKey}
            onSelect={onSelect}
            selectedOptionProp={selectedOptionProp}
            title={title}
            heightProp="4.2rem"
            backgroundColorProp="#00000000"
            borderRadiusProp="1rem"
            fontSizeTitle="1.2rem"
            fontSizeText="1.4rem"
            widthProp={width}
            enableSearch={enableSearch}
            enableClear={enableClear}
            onClear={(e) => onClear(e)}
            type={type}
          />
        </DivRow>
      </DivColumn>
    );
  }

  function metricsSummaryRow(comparisonLayout = false) {
    return (
      <DivRow className="dashboard-4-frame-4">
        <DivRow className="dashboard-4-frame-5">
          {metricSummaryItem({ percentage: comparisonLayout ? getMainMeasurePercentComparison(1) : getMainMeasurePercent(1), title: ConstantsTexts.CODE_148 })}
        </DivRow>
        <DivColumn className="dashboard-4-frame-6">
          <DivRow className="dashboard-4-frame-7">
            {metricSummaryItem({ percentage: comparisonLayout ? getMainMeasurePercentComparison(3) : getMainMeasurePercent(3), title: ConstantsTexts.CODE_149 })}
          </DivRow>
        </DivColumn>
        <DivColumn className="dashboard-4-frame-8">
          <DivRow className="dashboard-4-frame-9">
            {metricSummaryItem({ percentage: comparisonLayout ? getMainMeasurePercentComparison(2) : getMainMeasurePercent(2), title: ConstantsTexts.CODE_150 })}
          </DivRow>
        </DivColumn>
      </DivRow>
    );
  }

  function metricSummaryItem({ percentage, title }) {
    return (
      <>
        <ParagraphText className="dashboard-text-4">{percentage}</ParagraphText>
        <ParagraphText className="dashboard-text-5">{title}</ParagraphText>
      </>
    );
  }

  function legendContainer() {
    return (
      <DivRow className="dashboard-5-frame">
        {legendItem({ width: "4.8rem", backgroundColor: "#CACACA", title: ConstantsTexts.CODE_151 })}
        {legendItem({ width: "4.4rem", backgroundColor: "#FFF", title: ConstantsTexts.CODE_152 })}
      </DivRow>
    );
  }

  function legendItem({ width, backgroundColor, title }) {
    return (
      <DivColumn className="dashboard-5-frame-1">
        <DivRow className="dashboard-5-frame-2" style={{ width: width, backgroundColor: backgroundColor }}>
          <ParagraphText className="dashboard-text-6">{title}</ParagraphText>
        </DivRow>
      </DivColumn>
    );
  }

  // Renders virtualized terminal list with comparison mode support and selection highlighting
  function terminalsList() {
    const Row = ({ index, style }) => {
      const item = nationalModelForTerminalFiltered[index];
      return (
        <div style={style}>
          <DivRow key={index} className="dashboard-6-frame-container" style={{ backgroundColor: isTerminalRowSelected(item, selectedItemId) ? "#e0e0e0" : "transparent" }}>
            {terminalListItem({ item })}
            {terminalMetricsRow({ item })}
            {terminalRankRow({ item })}
            {isComparisonMode && (
              <>
                {terminalMetricsRow({ item, comparisonLayout: true })}
                {terminalRankRow({ item, comparisonLayout: true })}
              </>
            )}
          </DivRow>
        </div>
      );
    };

    return (
      <WidgetFixedSizeList
        listRef={listRef}
        height={60}
        width={getDashboardFrameWidth(true)}
        itemCount={nationalModelForTerminalFiltered?.length || 0}
        itemSize={6}
        style={{
          transition: "width 0.3s ease-in-out",
        }}
      >
        {Row}
      </WidgetFixedSizeList>
    );
  }

  function terminalListItem({ item }) {
    return (
      <DivRow className="dashboard-6-frame">
        <DivColumn className="dashboard-6-frame-1" onClick={() => handleSelectTerminalFromList(item)}>
          <ParagraphText className="dashboard-text-7">{item.terminalName}</ParagraphText>
          <ParagraphText className="dashboard-text-8">{item.erezSKU}</ParagraphText>
        </DivColumn>
        {terminalStatusTextItem({ width: "6.7rem", title: item.terminalStatus })}
        <DivRow className="dashboard-6-frame-2">
          <WidgetIconFive iconProp={ConstantsImages.MARKER_2_IMAGE} widthIconProp="1.2rem" heightIconProp="1.4rem" />
          <ParagraphText className="dashboard-text-10">{item.municipalityName}</ParagraphText>
          <ParagraphText className="dashboard-text-11">{item.districtMOT}</ParagraphText>
        </DivRow>
        <DivRow className={`dashboard-6-frame-3 ${isCollapsed ? "collapsed" : ""}`}>
          {terminalStatusTextItem({ width: "5.5rem", title: item.terminalType })}
          {terminalStatusTextItem({ width: "9rem", title: item.budgetStatus })}
          {terminalStatusTextItem({ width: "5.9rem", title: item.organizationInCharge })}
        </DivRow>
      </DivRow>
    );
  }

  function terminalStatusTextItem({ width, title }) {
    return (
      <ParagraphText className="dashboard-text-12" style={{ width: width }}>
        {title}
      </ParagraphText>
    );
  }

  function terminalMetricsRow({ item, comparisonLayout = false }) {
    return (
      <DivRow className="dashboard-7-frame-5">
        <DivRow className="dashboard-7-frame-1">
          <GaugeUI numberText={comparisonLayout ? item.urgencyMeasure2 : item.urgencyMeasure} />
          <GaugeUI numberText={comparisonLayout ? item.importanceMeasure2 : item.importanceMeasure} />
          <GaugeUI numberText={comparisonLayout ? item.potentialMeasure2 : item.potentialMeasure} />
          <GaugeUI numberText={comparisonLayout ? item.operationalGapsMeasure2 : item.operationalGapsMeasure} />
        </DivRow>
        <DivColumn className="dashboard-7-frame-2">
          <GaugeUI numberText={comparisonLayout ? item.municipalityPositionMeasure2 : item.municipalityPositionMeasure} />
        </DivColumn>
        <DivRow className="dashboard-7-frame-3">
          <GaugeUI numberText={comparisonLayout ? item.costPerTripMeasure2 : item.costPerTripMeasure} />
          <GaugeUI numberText={comparisonLayout ? item.costPerPassengerMeasure2 : item.costPerPassengerMeasure} />
        </DivRow>
      </DivRow>
    );
  }

  function terminalRankRow({ item, comparisonLayout = false }) {
    return (
      <DivRow className="dashboard-7-frame-4">
        <GaugeUI
          numberText={comparisonLayout ? item.totalPoints2 : item.totalPoints}
          backgroundColor={UtilsUnit.getLighterColor(item.totalPoints)}
          textColor="#FFF"
          textWeight="800"
        />
        <GaugeUI numberText={comparisonLayout ? item.terminalRank2 : item.terminalRank} backgroundColor="#FFF" textColor="#2E2E2E" textWeight="800" />
      </DivRow>
    );
  }

  function mapUi() {
    return (
      <DivRow className="dashboard-8-frame">
        <div style={{ height: "91.5rem", width: getMapWidth() }}>
          <div style={{ position: "relative" }}>
            <WidgetMarkersMap
              centerProp={UtilsUnit.getCenterPropForMap()}
              heightProp="91.5rem"
              widthProp={getMapWidth()}
              transitionProp="width 0.3s ease-in-out"
              markers={mapMarkers}
              hasActiveFilters={hasActiveFilters}
              zoomCoordinates={getZoomCoordinates()}
              showPinMarkers={false}
            />
          </div>
          <DivRow className="dashboard-8-frame-1" onClick={handleToggleCollapse}>
            <WidgetIconFive iconProp={ConstantsImages.VERTICAL_DOTS_IMAGE} widthIconProp="0.4rem" heightIconProp="3.3rem" />
          </DivRow>
        </div>
      </DivRow>
    );
  }

  function GaugeUI({ numberText, backgroundColor, textColor, textWeight }) {
    return <WidgetGaugeUI sizeProp="4.8rem" numberText={numberText} backgroundColor={backgroundColor} textColor={textColor} textWeight={textWeight} boxShadow="none" />;
  }
}

export default PageDashboard;
